import { t } from '@lingui/macro';
import { SlideTypes } from '../types';

export const getViewCtaCopy = (type?: SlideTypes) => {
    let copy;

    switch (type) {
        case SlideTypes.Labels:
            copy = t`View label`;
            break;

        case SlideTypes.Packs:
            copy = t`View pack`;
            break;

        case SlideTypes.Repacks:
            copy = t`View collection`;
            break;

        default:
            copy = t`View`;
            break;
    }

    return copy;
};
